import React, { useState, useEffect, useRef } from 'react';
import { getStockHistoryList, exportStockHistoryApi } from '../../../services/ProductService';
import Pagination from '../../constant/Pagination';
import { CancelRequest } from '../../../services/AxiosInstance';
import { Link } from 'react-router-dom';
import TableLoaderEffect from '../../constant/TableLoader';
import { connect } from 'react-redux';
import Select from 'react-select'
import DebounceSearchInput from '../../constant/DebounceSearchInput';
import StockHistoryTypeBadge from '../../constant/StockHistoryTypeBadge';
import CustomDateRangePicker from '../../constant/CustomDateRangerPicker';
import { convertPeriodToDate } from '../../../utils';
import ExportModal from '../../constant/ExportModal';

const statusBtnList = ["All", "In", "Out"]

const HistoryTypeOptiosList = [
    "NEW MATERIAL",
    "RETURN MATERIAL",
    "BORROWING MATERIAL",
    "MATERIAL CONSUMPTION",
    "RETURN BORROWED MATERIAL",
    "LENDING MATERIAL",
    "RECEIVE LENT MATERIAL"
]

const StockHistory = ({ stockUpdateKey }) => {
    const { from: defaultFrom, to: defaultTo } = convertPeriodToDate('last_7_days');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState(statusBtnList[0]);
    const [historyType, setHistoryType] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState({ value: "last_7_days", label: "Last 7 Days" })
    const [fromDate, setFromDate] = useState(defaultFrom);
    const [toDate, setToDate] = useState(defaultTo);
    const [historyTypeOtpion, setHistoryTypeOption] = useState(HistoryTypeOptiosList.map(item => ({ value: item, label: item })));
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const recordsPage = 25;
    const isApiCalled = useRef(false); // Prevents duplicate API calls
    

    useEffect(() => {
        if (isApiCalled.current) return; // Skip second execution

        setIsLoading(true);
        getStockHistoryList(currentPage, recordsPage, searchQuery, statusFilter, historyType?.value || "", fromDate, toDate)
            .then((resp) => {
                if (resp) {
                    setData(resp.data.data);
                    setTotal(resp.data.total);
                }
            })
            .catch((error) => {
                console.log(error.response?.data?.message);
            })
            .finally(() => {
                setIsLoading(false);
            });

    }, [currentPage, recordsPage, searchQuery, statusFilter, stockUpdateKey, historyType, fromDate, toDate]);

    const handlePagination = (page) => {
        isApiCalled.current = false;
        const new_page = page.selected + 1
        setCurrentPage(new_page)
    }

    const handleSearchChange = (newQuery) => {
        setSearchQuery(newQuery)
        setCurrentPage(1)
    }

    const handleHistoryStatus = (status) => {
        isApiCalled.current = false;
        setStatusFilter(status)
        setCurrentPage(1)
        let HistoryOptiosList = ["NEW MATERIAL",
            "RETURN MATERIAL",
            "BORROWING MATERIAL",
            "MATERIAL CONSUMPTION",
            "RETURN BORROWED MATERIAL"]
        if (status === "In") {
            HistoryOptiosList = ["NEW MATERIAL", "RETURN MATERIAL", "BORROWING MATERIAL",]
        } else if (status === "Out") {
            HistoryOptiosList = ["MATERIAL CONSUMPTION", "RETURN BORROWED MATERIAL"]
        }
        setHistoryType(null)
        setHistoryTypeOption(HistoryOptiosList.map(item => ({ value: item, label: item })))
    }

    const handleHistoryTypeChange = (data) => {
        isApiCalled.current = false;
        setHistoryType(data)
        setCurrentPage(1)
    }


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center p-3 mb-1">
                                <h4 className="mb-0">Stock History</h4>
                                <div>
                                    <ExportModal
                                        exportApi={exportStockHistoryApi}
                                        params={
                                            {
                                                query: searchQuery,
                                                status: statusFilter,
                                                history_type: historyType?.value || '',
                                                from_date: fromDate,
                                                to_date: toDate
                                            }
                                        }
                                        title="Export Stock History"
                                    />

                                </div>
                            </div>

                            <div className="tbl-caption d-flex justify-content-between gap-2 align-items-center px-3 mb-2">
                                <CustomDateRangePicker
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    selectedPeriod={selectedPeriod}
                                    onChange={({ fromDate, toDate, selectedPeriod }) => {
                                        setFromDate(fromDate);
                                        setToDate(toDate);
                                        setSelectedPeriod(selectedPeriod);
                                        setCurrentPage(1)
                                    }}
                                    isClearable={true}
                                />

                                <div className='d-flex align-items-center flex-wrap gap-2'>

                                    <div>
                                        <div className="btn-group" role="group" aria-label="Small button group">
                                            {statusBtnList.map(item => (
                                                <button key={item} type="button"
                                                    className={`btn ${statusFilter === item ? "btn-primary" : "btn-outline-primary"}`}
                                                    onClick={() => handleHistoryStatus(item)}>{item}</button>
                                            ))}
                                        </div>
                                    </div>


                                    <Select
                                        value={historyType}
                                        onChange={(data) => handleHistoryTypeChange(data)}
                                        placeholder={"History Type"}
                                        isClearable={true}
                                        options={historyTypeOtpion}
                                        id={'history-type'}
                                        className='react-select'
                                        classNamePrefix='select'
                                    />

                                    <div className='form-group'>
                                        <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                    <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Rack</th>
                                                <th>Quantity</th>
                                                <th>Status</th>
                                                <th>Date</th>
                                                <th>Employee</th>
                                                <th>Barcode</th>
                                                <th>User</th>
                                                <th>Source / Purpose</th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? <TableLoaderEffect colLength={9} /> : data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <Link to={`/material/${item.stock.product.id}`} className='text-primary fw-bold'>{item.stock.product.name}</Link>
                                                            <small>{item.stock.product.ucs_code}</small>
                                                        </div>
                                                    </td>
                                                    <td><Link to={`/rack/${item.stock.rack.id}`}>{item.stock.rack ? item.stock.rack.rack_no : null}</Link></td>
                                                    <td><span>{item.quantity}</span></td>
                                                    <td>
                                                        {item.is_stock_out ? (
                                                            <span className={`badge light border-0 badge-danger`}>OUT</span>
                                                        ) : (
                                                            <span className={`badge light border-0 badge-success`}>IN</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span>{item.created_at}</span>
                                                            <div>
                                                                <StockHistoryTypeBadge historyType={item.history_type} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span>{item?.employee?.name || ""}</span>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span>{item.stock.barcode_no}</span>
                                                            {["REQUISITION", "RESERVATION"].includes(item.history_type) && item.reference_no ? (
                                                                <span>
                                                                    <span className={`badge badge-sm light border-0 badge-dark`}>{item.reference_no}</span>
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span>{item.user?.name || "User Deleted"}</span>
                                                            <small>{item.user?.email}</small>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <span>
                                                            {item.source ? item.source : item?.purpose ? (
                                                                <small className="px-2 py-1 text-bg-light border border-light rounded-2">{item.purpose}</small>
                                                            ) : ""}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {isLoading ? <div style={{ height: '4rem' }}></div> : <Pagination
                                        currentPage={currentPage}
                                        recordsPage={recordsPage}
                                        dataLength={total}
                                        handlePagination={handlePagination}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        stockUpdateKey: state.auth.stockUpdateKey,
    };
};
export default connect(mapStateToProps)(StockHistory);